export const agents = [{
  "_id": {
    "$oid": "63fd93833913e1b0fd8f4192"
  },
  "name": "Club Monks",
  "street": "B-34, Kartikey Colony, Kusumkhera",
  "city": "haldwani",
  "state": "Nainital",
  "email": "clubmonks@gmail.com",
  "phone": " 073005765",
  "website": "clubmonks.in",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd95301dd24c17a49884d0"
  },
  "name": "Abhishri Tours Pvt Ltd",
  "street": "6 saharanpur road patel nagar,",
  "city": "dehradun",
  "state": "Uttrakhand",
  "email": "b_rana_99@yahoo.com",
  "phone": "0965072584, Ph: 0135-2550910",
  "website": "www.char-dham.in",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9757f4a3e02f70e13cae"
  },
  "name": "Sanjeevani Travels",
  "street": "6 saharanpur road patel nagar",
  "city": "dehradun",
  "state": "Uttrakhand",
  "email": "info@sanjeevnitravels.com",
  "phone": "3412054672, Ph: 0135-2721458",
  "website": "http://sanjeevnitravels.com/",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd993af4a3e02f70e13cb6"
  },
  "name": "Namami Gange Tour And Travels",
  "street": "Gali no 4,258 Shivpuri Colony",
  "city": "haridwar",
  "state": "Uttrakhand",
  "email": "alka_977@rediffmail.com",
  "phone": " 6303981207, 630398120",
  "website": "www.namamigangetravels.in",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9a09f4a3e02f70e13cb8"
  },
  "name": "Aryon Tourism Opc Pvt. Ltd.",
  "street": "Ward No. 2",
  "city": "gadarpur",
  "state": "US Nagar,Uttakhand",
  "email": "info@aryon.in",
  "phone": "6396375203",
  "website": "www.aryon.in",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9a9df4a3e02f70e13cba"
  },
  "name": "Sharma Travels",
  "street": "214 s n nagar",
  "city": "haridwar",
  "state": "Uttakhand",
  "email": "smrrr3@gmail.com",
  "phone": " 7017071682, 7017071682",
  "website": "",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9b3ff4a3e02f70e13cbc"
  },
  "name": "Aar Kay Travel & Tour",
  "street": "214 s n nagarHotel Nand Residency, Kulri, Mussoorie",
  "city": "dehradun",
  "state": "Uttaranchal",
  "email": "aarkaytraveltours@gmail.com",
  "phone": " 7017443850, Ph: 0135-2631442",
  "website": "",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9bedf4a3e02f70e13cbe"
  },
  "name": "Yatracar.Com ",
  "street": "A4 Gangotri Apartments, Gangotri Vihar Dhalwala, Rishikesh",
  "city": " rishikesh, tehri",
  "state": "Uttaranchal",
  "email": "saritadhanai055@gmail.com",
  "phone": " 7017727836",
  "website": "",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9cb6f4a3e02f70e13cc0"
  },
  "name": "Rafting Ganga Adventure",
  "street": "CHANDRESHWAR MARG CHANDRESHWAR NAGAR",
  "city": " rishikesh, dehradun",
  "state": "Uttaranchal",
  "email": "RAFTINGGANGAADVENTUER@GMAIL.COM",
  "phone": "7037500025, 9997500025",
  "website": "WWW.RAFTINGGANGAADVENTURE.COM",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9d11f4a3e02f70e13cc2"
  },
  "name": "Ganpati Tours",
  "street": "Wildlife institute road, Chandrabani",
  "city": " rishikesh, dehradun",
  "state": "Uttaranchal",
  "email": "ganpatitours@outlook.com",
  "phone": "7055333356",
  "website": "https://www.ganpatitours.com",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9daef4a3e02f70e13cc4"
  },
  "name": "Uttarakhand Trips",
  "street": "Birla Farm Chowk, Haripur Kalan",
  "city": " rishikesh, dehradun",
  "state": "Uttaranchal",
  "email": "akshayshahu000@gmail.com",
  "phone": " 7055455443",
  "website": "https://www.uttarakhandtrips.com/",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9e72f4a3e02f70e13cc6"
  },
  "name": "Devexcursion Private Limited",
  "street": "D 1 3-2 /03 Radisson Blue Hotel",
  "city": "rudrapur",
  "state": "Uttarakhand",
  "email": "office@devexcursion.in",
  "phone": "7060017982-7060017982",
  "website": "https://www.uttarakhandtrips.com/",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9f69f4a3e02f70e13cc8"
  },
  "name": "Traveloi Holiday",
  "street": "HN-106, Lane 2, Block B, Mandakini Vihar, sahastra",
  "city": "dehradun",
  "state": "Uttaranchal",
  "email": "info@traveloi.com",
  "phone": "7060106084, Ph: 0135-2608568",
  "website": "http://traveloi.com/",
  "__v": 0
},{
  "_id": {
    "$oid": "63fd9fe7f4a3e02f70e13cca"
  },
  "name": "Sita Ram Travels",
  "street": "Rishikesh road near jain mandir bhpatwala",
  "city": "haridwar",
  "state": "Uttrakhand",
  "email": "amitvermahindustantour@gmail.com",
  "phone": "7060338741, 7060338741",
  "website": "http://sitaramtravel.in",
  "__v": 0
}]